"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegionById = getRegionById;
function getRegionById(regionId) {
  switch (true) {
    case [1, 4593, -1].includes(regionId):
      return 'msk';
    case [2, 4588, -2].includes(regionId):
      return 'spb';
    default:
      return 'other';
  }
}